<template>
<div id="Business">
        <div class="top-row">

          <figure class="figure">
            <img @click="selectBusiness(false,
             '33.ogg')"
            alt="Эконом"
            title="Эконом"
            class="img-fluid"
            src="../assets/Economy.jpg">
            <figcaption class="figure-caption text-center">
              Эконом</figcaption>
          </figure>
           <figure class="figure">
            <img @click="selectBusiness(true,
             '34.ogg')"
            alt="Бизнес"
            title="Бизнес"
            class="img-fluid"
            src="../assets/Business.jpg">
            <figcaption class="figure-caption text-center">
              Бизнес</figcaption>
          </figure>
        </div>
        <div class="middle-row">

          </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  created() {
    this.$say('5.ogg');
  },
  methods: {
    ...mapActions('calc', ['setBusiness']),
    selectBusiness(item, text) {
      this.setBusiness(item);
      this.$router.push('/calculator18');
      this.$say(text);
    },
  },

};
</script>

<style scoped>
.top-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
}
.middle-row {
  padding-top:30px;
  display:flex;
  justify-content: space-around;
}
img {
padding:5px;
}
img:hover{
    cursor: pointer;
}
</style>
